/****************************************************
 * Module Name:  addSizeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import SizeProxy from "../../utility/proxy/manager/sizeProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddSizeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newfromsize: this.props.editOperation
        ? this.props.sourceData.fromsize
        : "",
      newtosize: this.props.editOperation ? this.props.sourceData.tosize : "",
      newsize: this.props.editOperation ? this.props.sourceData.name : "",
      newfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",

      showError: false,

      validateSizePresentSpinner: false,
      showValidationMessage: false,
      sizeAvailable: true,

      fromSizeValidationError: "",
      toSizeValidationError: "",
      sizeValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      fromsize: parseFloat(this.state.newfromsize).toFixed(3),
      tosize: parseFloat(this.state.newtosize).toFixed(3),
      name: this.state.newsize,
      fullname: this.state.newfullname,
      description: this.state.newdescription,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateSizePresent = (sizeEntered) => {
    if (!sizeEntered || sizeEntered.trim() === "") return;

    this.setState({
      validateSizePresentSpinner: true,
    });

    SizeProxy.CheckSizeAvailable(sizeEntered, (response) => {
      //if we got response that means size is present at backend
      if (response) {
        //SizeName already present
        this.setState({
          validateSizePresentSpinner: false,
          showValidationMessage: true,
          sizeAvailable: false,
        });
      } else {
        //SizeName not available, so can be used
        this.setState({
          validateSizePresentSpinner: false,
          showValidationMessage: true,
          sizeAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      this.state.newfromsize.length === 0 &&
      this.state.newsize.length === 0 &&
      this.state.newtosize.length === 0 &&
      this.state.newfullname.length === 0
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.sizeAvailable ||
        this.state.newfromsize.length === 0 ||
        this.state.newsize.length === 0 ||
        this.state.newtosize.length === 0 ||
        this.state.newfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add size validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Size" : "Add New Size"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Size Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        From size <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="From size (required)"
                        placeholder="Enter From size"
                        value={this.state.newfromsize}
                        onBlur={(e) =>
                          this.state.newtosize.length > 0 &&
                            !this.state.showValidationMessage
                            ? this.validateSizePresent(this.state.newsize)
                            : ""
                        }
                        onChange={(e) =>
                          this.setState({
                            newfromsize: e.target.value,
                            newsize:
                              e.target.value + "-" + this.state.newtosize,
                            fromSizeValidationError: Utility.CheckisNumberPositive(
                              e.target.value
                            )
                              ? ""
                              : "From size should be a valid positive number and Cannot be Empty",
                          })
                        }
                        helperText={this.state.fromSizeValidationError}
                        error={this.state.fromSizeValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        To Size <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="To Size (required)"
                        placeholder="Enter To Size"
                        value={this.state.newtosize}
                        onBlur={(e) =>
                          this.state.newfromsize.length > 0 &&
                            !this.state.showValidationMessage
                            ? this.validateSizePresent(this.state.newsize)
                            : ""
                        }
                        onChange={(e) =>
                          this.setState({
                            newtosize: e.target.value,
                            newsize:
                              this.state.newfromsize + "-" + e.target.value,
                            toSizeValidationError: Utility.CheckisNumberPositive(
                              e.target.value
                            )
                              ? ""
                              : "To Size should be a valid positive number and Cannot be Empty",
                          })
                        }
                        helperText={this.state.toSizeValidationError}
                        error={this.state.toSizeValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Size <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newsize}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Size (required)"
                          placeholder="Enter Size"
                          value={this.state.newsize}
                          autoFocus
                          onBlur={(e) =>
                            this.validateSizePresent(this.state.newsize)
                          }
                          onChange={(e) => {
                            this.setState({
                              newsize: e.target.value,
                              showValidationMessage: false,
                              sizeValidationError: Utility.CheckIsNumberAndHyphen(
                                e.target.value
                              )
                                ? ""
                                : "Size should be a valid positive number and Cannot be Empty",
                            });
                          }}
                          helperText={this.state.sizeValidationError}
                          error={this.state.sizeValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateSizePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.sizeAvailable ? (
                        <font color="green">Size available</font>
                      ) : (
                        <font color="red">Size not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Size Fullname (required)"
                        placeholder="Enter Size Fullname"
                        value={this.state.newfullname}
                        onChange={(e) =>
                          this.setState({
                            newfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Size Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
